<template>
<div style="height:100%;">
<v-card style="height:100%;">
    <v-toolbar
      flat
      height="auto"
      class="elevation-5"
    >
    <v-row>
        <v-col  sm="12" md="6" lg="3" cols="12">
            <v-toolbar-title style="white-space: pre-wrap; word-wrap: break-word;">
                <h4>Системы навигации</h4>
                <h6 class="text--disabled">Подключите внешние системы мониторинга для эффективного анализа данных</h6>
            </v-toolbar-title>
        </v-col>
        <v-spacer/>
          <v-col class="d-sm-flex flex-row-reverse" sm="12" md="12" lg="6" cols="12" xl="6" style="width:auto;" v-if="window.width >= 960">
          <v-btn @click="LoadData" v-bind:disabled="loading" x-large color="primary" class="mx-1 mb-1 px-5" max-width="224px">
            <v-icon left x-large class="pr-2 ml-2">mdi-refresh</v-icon>
            Обновить
          </v-btn>
          <CreateAccountForm
            buttonText="Добавить"
            buttonIcon="mdi-access-point-plus"
            v-on:onValidate="CreateAccountButtonOnClick"
            :enabled="loading"/>
        </v-col>
        <v-col class="d-inline flex-row-reverse" sm="12" md="12" lg="6" cols="12" xl="6" style="width:auto;" v-else>
          <CreateAccountForm
            buttonText="Добавить"
            buttonIcon="mdi-access-point-plus"
            adaptive
            :enabled="loading"
            v-on:onValidate="CreateAccountButtonOnClick"/>
          <v-btn @click="LoadData" v-bind:disabled="loading" block large color="primary" class="mb-1" max-width="224px">
            <v-icon left large class="pr-2 ml-2">mdi-refresh</v-icon>
            Обновить
          </v-btn>
        </v-col>
    </v-row>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Поиск.."
        single-line
        v-bind:disabled="loading"
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-text style="padding:0px;width:100%">
      <v-skeleton-loader
            v-if="loading"
            style="height:100%"
            type="table"
            tile
          >
          </v-skeleton-loader>
        <div v-else class="fill-height table-container">
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 15]
            }"
            :search="search"
            :headers="headers"
            :items="atkAccounts"
            style="margin-bottom:50px;"
          >

          <template v-slot:item.actions="{ item }">
            <v-icon
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:item.isActive="{ item }">
            <div v-if="item.isActive" class="my-auto">
              <v-icon color="success" large>mdi-access-point</v-icon> Подключен
            </div>
            <div v-else class="my-auto">
              <v-icon color="error" large>mdi-access-point-off</v-icon> Отключен <v-btn color="primary" class="ml-2" x-small  @click="showStatusDescription(item)">Причина отключения</v-btn>
            </div>
          </template>
          <template v-slot:item.lastUpdateDateTime="{ item }">
            {{calculateLastUpdateDate(item.lastUpdateDateTime)}}
          </template>
          </v-data-table>
        </div>
    </v-card-text>
    </v-card>
    <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline primary mb-5">
          Почему эта система отключена?
        </v-card-title>

        <v-card-text class="text--primary">
          <p>{{dialogText}}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Продолжить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import CreateAccountForm from '../../components/CreateAccountForm'

export default {
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    CreateAccountForm
  },
  data () {
    return {
      dialog: false,
      dialogText: '',
      search: '',
      headers: [
        { value: 'isActive' },
        { value: 'lastUpdateDateTime', text: 'Последнее обновление' },
        {
          text: 'URL Адрес',
          align: 'start',
          sortable: false,
          value: 'uri'
        },
        { text: 'Логин', value: 'login' },
        { text: 'Система мониторинга', value: 'accountType' },
        { text: 'Действия', value: 'actions', sortable: false }
      ],
      transition: 'expand-transition',
      hide: true,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  computed: {
    ...mapState('AtkAccount', {
      atkAccounts: state => state.atkAccounts,
      loading: state => state.loading
    })
  },
  mounted () {
    this.LoadData()
    document.title = 'Системы мониторинга - ATK Web'
  },
  methods: {
    ...mapActions({
      getAccounts: 'AtkAccount/getAccounts',
      createAccount: 'AtkAccount/createAccount',
      deleteAccount: 'AtkAccount/deleteAccount'
    }),
    calculateLastUpdateDate (date) {
      const currentDate = new Date(date)
      const GMT_DIFF = -new Date().getTimezoneOffset() / 60
      currentDate.setHours(currentDate.getHours() + GMT_DIFF)
      return currentDate.toLocaleDateString('ru-RU', { month: 'short', day: 'numeric', year: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    getLocaleDateTime (userRegionDate) {
      return new Date(Date.UTC(userRegionDate.getFullYear, userRegionDate.getMonth(), userRegionDate.getDate(), userRegionDate.getHours(), userRegionDate.getMinutes))
    },
    showStatusDescription (item) {
      // alert('Причина блокировки: ' + item.description)
      this.dialogText = 'Причина блокировки - ' + item.description
      this.dialog = true
    },
    accountTypeRename (item) {
      switch (item) {
        case 500: return 'АвтоГРАФ Web'
        case 600: return 'Wialon'
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    LoadData () {
      this.getAccounts()
    },
    CreateAccountButtonOnClick (data) {
      switch (data.accountType) {
        case 'АвтоГРАФ Web' : data.accountType = 500
          break
        case 'Wialon (недоступен)' : data.accountType = 600
          break
      }
      this.createAccount(data)
    },
    deleteItem (item) {
      // const index = this.atkAccounts.indexOf(item)
      confirm(`Вы действительно хотите удалить профиль ${item.login} (${item.uri}) ?`) && this.deleteAccount(item.id)
    }
  }
}
</script>
<style scoped>
.table-container {
  min-width: 290px;
  max-width: 100%;
  width:100%;
  box-sizing: content-box;
}

table {
  width: 100%;
  padding: 0;
}

table td, table th {
  padding: 5px;
  margin: 5px;
}

@media (max-width: 720px) {

  .table-container table thead {
    display: none;
  }

  .table-container table tr {
    display: block;

  }
  .table-container table td {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    padding:0px;
  }

  .table-container table td::before {
    content: attr(data-label);
    white-space: pre-wrap;
    word-wrap: break-word;
    font-weight: bold;
    margin-right: 0;
  }

}
</style>
